import script from "./PaymentSuccessView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentSuccessView.vue?vue&type=script&setup=true&lang=js"

import "./PaymentSuccessView.vue?vue&type=style&index=0&id=225ab95c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-225ab95c"]])

export default __exports__